import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass/styled-components';
import PolicySection from './PolicySection';
import EditorLabel from '../Editor/EditorLabel';
import EditorContainer from '../Editor/EditorContainer';
import EditorButton from '../Editor/EditorButton';

function PolicyException(props) {
  const {
    isEditing,
    setException,
    exception,
    skills,
    agents,
    intents,
    customAttributes,
  } = props;

  const hasConditions = exception.conditions && exception.conditions.length;
  const hasActions = exception.actions && exception.actions.length;

  const addException = () => setException({
    conditions: hasConditions ? exception.conditions : [{ value: '', type: 'EQUAL', property: '' }],
    actions: hasActions ? exception.actions : [{ type: 'SEND_MESSAGE', payload: { message: '' } }],
  });

  const removeException = () => setException({});

  if (!hasConditions && !hasActions) {
    return isEditing ? (
      <EditorContainer mt={3} mb={2}>
        <EditorLabel largeSized>Exception</EditorLabel>
        <Box ml={12}>
          <EditorButton onClick={addException} testid="add-override" variant="add">Add override exception</EditorButton>
        </Box>
      </EditorContainer>
    ) : null;
  }

  return (
    <EditorContainer mt={3} mb={2} data-testid="editor-exception">
      <EditorLabel largeSized>Exception</EditorLabel>
      {isEditing ? (
        <Box ml={12}>
          <EditorButton
            variant="delete"
            onClick={removeException}
            testid="remove-override"
          >
            Remove override exception
          </EditorButton>
        </Box>
      ) : null}
      <PolicySection
        sectionType="conditions"
        temporaryPolicy={exception}
        isEditing={isEditing}
        customAttributes={customAttributes}
        intents={intents}
        noMargin
        validateObject={setException}
      />
      <PolicySection
        sectionType="actions"
        temporaryPolicy={exception}
        isEditing={isEditing}
        skills={skills}
        agents={agents}
        intents={intents}
        customAttributes={customAttributes}
        noMargin
        validateObject={setException}
      />
    </EditorContainer>
  );
}

PolicyException.defaultProps = {
  isEditing: false,
  setException: null,
  exception: {},
};

PolicyException.propTypes = {
  isEditing: PropTypes.bool,
  setException: PropTypes.func,
  exception: PropTypes.object,
  skills: PropTypes.array.isRequired,
  agents: PropTypes.array.isRequired,
  intents: PropTypes.array.isRequired,
  customAttributes: PropTypes.array.isRequired,
};

export default PolicyException;
